import * as React from 'react'

import {getItemUrl} from '@frontrow/console/src/entities/models/item'

import * as style from './avatar-with-item.module.scss'

type Props = {
  avatarName: string
  itemName: string
  itemCategory: string
  grade: number
  addClass?: string
}

export default function AvatarWithItem(props: Props): React.ReactElement {
  const {avatarName, itemName, itemCategory, grade, addClass} = props
  const avatarPose = 'normal'

  const imgixQueryParams = '?w=360&h=586'
  const avatarUrlBase = getItemUrl({
    itemName: avatarName,
    itemCategory: 'avatar',
    avatarName,
    avatarPose,
    studentGrade: grade,
    trimmedImage: false,
    itemVariationName: null
  })
  const avatarUrl = `${avatarUrlBase}${imgixQueryParams}`

  const itemUrlBase = getItemUrl({
    itemName,
    itemCategory,
    avatarName,
    avatarPose,
    studentGrade: grade,
    trimmedImage: false,
    itemVariationName: null
  })

  const itemUrl = `${itemUrlBase}${imgixQueryParams}`

  const hideAvatar = itemCategory === 'avatar' || itemCategory === 'background'

  const avatarNode = hideAvatar ? null : (
    <img title={avatarName} alt={avatarName} src={avatarUrl} className={style.avatarImg} />
  )

  return (
    <div className={`${style.wrapper} ${addClass || ''}`}>
      <div className={style.itemWrapper}>
        <img title={itemName} alt={itemName} src={itemUrl} className={style.itemImg} />
      </div>
      {avatarNode}
    </div>
  )
}
